/**
 * 绑定手机
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang';
import PbAjax from '../../lib/pbajax';
import Cache from 'c-cache';
import notification from 'c-notification';

import CountryView from '../../component/select-country/country-view';

import Timer from 'c-timer';
import confirmPopup from '../../lib/popup/confirm';
import codepb from './smscode.pb';
import loading from 'c-up-loading';
import bindphonepb from './bindphone.pb';
import publicpb from '../../base/public.pb';
import md5 from '../../base/md5';
import registerPb from '../../component/thirdparty-login/thirdparty/register.pb';
import {hex_md5} from '../../base/md5';

let pbajax = new PbAjax();
let cache = new Cache({
    prefix: 'pcuplive'
});

class BindPhoneView  extends Component {
    static defaultProps = {
        content: '',
        onCancel: function(){}
    }
    constructor(props){
        super(props);

        this.state = {
            showSelect: false,
            disVerifyCode: false,
            hidePwd: true
        }
    }

    componentDidMount(){
        let self = this;
        let el = $(this.refs.areaCode);

        el.on({
            mouseenter: function(e) {
                // self.setState({
                //  showSelect: true
                // });
            },
            mouseleave: function(e) {               
                self.setState({
                    showSelect: false
                });
            },
            click: function(e) {                
                self.setState({
                    showSelect: true
                });
            }
        });

        $(document.body).on('click', (e)=>{
            let el = $(e.target);
            let showSelect = false;
            
            if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
                showSelect = true;
            }

            this.setState({
                showSelect
            });
        });

        UP.Global.DA.add({
            eventName: 'showbindPhoneView',
            action: 'show'
        });
    }

    componentWillUnmount(){
        $(document.body).off('click');
        this.timer && this.timer.destroy();
    }
    
    
    handleSubmit = (e)=>{
        if (this.isFetching) {
            return;
        }

        if (!this.state.code) {
            notification.simple(lang.template('选择国家或地区'));
            this.setState({
                showSelect: true
            });
            return;
        }
        
        if (this.verify()) {
            this.isFetching = true;
            
            loading.show({
                content: lang.template('正在绑定...')
            });
            this.submit();
        }
    }

    submit() {
        let self = this;
        let phone =  this.refs.phone.value.trim();
        let smsCode = this.refs.verifyCode.value.trim();
        let password = this.refs.password.value.trim();

        const { Request, Response } = registerPb.ThirdCheck.Register;
        let mobilePhone = this.state.areaCode + '' + phone;
        
        let businessData = new Request({
            bind: 1,
            bindType: 1,
            mobilePhone: mobilePhone,
            smsCode:  smsCode,
            password: hex_md5(password),
            countryCode: this.state.code
        });

        let requestData = {
            service: 'service',
            api: '/third/check/register',
            header: {
                userToken: UP.Global.getUserToken()
            }
        }

        UP.Global.DA.add({
            eventName: 'bindPhoneSendRequest',
            action: 'click'
        });

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                loading.hide();
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    UP.Global.updateUserInfo('mobilePhone', mobilePhone);
                    
                    notification.simple(lang.template('绑定成功'));
                    
                    self.props.onComplete(mobilePhone);

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendRequestSuccess',
                        action: 'click'
                    });
                } else {
                    if (dataWrap.code == 4099 ) {
                        notification.simple(lang.template('验证码错误！'))
                    } else {
                        notification.simple(lang.template('绑定失败'))
                    }

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendRequestError' + dataWrap.code,
                        action: 'click'
                    });
                }
                self.isFetching = false;
            },
            () => {
                loading.hide();
                self.isFetching = false;
            },
            () => {
                loading.hide();
                self.isFetching = false;
        });
    }

    verify () {
        let phone = this.refs.phone.value.trim();
        let password = this.refs.password.value.trim();
        let verifyCode = this.refs.verifyCode.value.trim();


        if (phone == '') {
            notification.simple(lang.template('请输入手机号码'));
            return false;
        }  else if (verifyCode == '') {
            notification.simple(lang.template('请输入验证码'));
            return false;
        } else if (password == ''){
            notification.simple(lang.template('请输入密码'));
            return false;
        }

        return true;
    }

    handleSelectCountry=()=>{
        if (this.state.showSelect) {
            return;
        }

        this.setState({
            showSelect: true
        });
    }

    clicVerifyCode=()=>{
        let self = this;
        let phone = $(this.refs.phone).val();


        if (phone.trim().length == 0) {
            notification.simple(lang.template('请输入手机号码'));
            return;
        } 

        if (this.state.disVerifyCode) {
            return;
        } else {
            self.getverifyCode();
        };      
    }

    getverifyCode() {
        let self = this;
        let { Request , Response } = codepb.Sms.SendCode;
        let phone = $(this.refs.phone).val().trim();

        let deviceId = this.getCurrentUuid();
        let ua = UP.Global.getDefaultUA();
        
        let s1 = md5.hex_md5 (md5.hex_md5(ua)  + deviceId );
        s1 = s1.substring(s1.length - 8);
        
        let s2 = md5.hex_md5(deviceId + 'jq5kmuqcWkrJD7M');
        s2 = s2.substring(s2.length - 24);

        let signature = s2 + s1;
        let mobilePhone = this.state.areaCode + '' + phone;

        let businessData = new Request({
            mobilePhone, 
            deviceId,
            signature,
            module: 'bindMobile'
        })
        
        UP.Global.DA.add({
            eventName: 'bindPhoneSendCode',
            action: 'click'
        });

        pbajax.do({
            service: 'service',    
            api :'/sms/send/code',
            header: {
                userToken: UP.Global.getUserToken(),
                UserAgent: ua
            }
        }, businessData, function(res){
            
            let dataWrap = publicpb.Result.decode(res), data;
            let tip = lang.template('系统错误');
            
            if (dataWrap.code == 1){
                let second = $('[data-second=second]');
                let code = second.parent('b');

                second.removeClass('hidden');
                code.addClass('dis');
                
                self.setState({
                    disVerifyCode: true
                });

                let timer = self.timer = new Timer({
                    remainTime : '60',
                    isDoubleBit: true,
                    selector : {
                        second : '[data-second]'
                    }
                });

                self.timer.on('end' , function () {
                    second.addClass('hidden');
                    code.removeClass('dis');
                    self.setState({
                        disVerifyCode: false
                    });
                });
                
                UP.Global.DA.add({
                    eventName: 'bindPhoneSendCodeSuccess',
                    action: 'click'
                });

            } else  {
                if (dataWrap.code == 4101) {
                    notification.simple(lang.template('此帐号已绑定'));
                } else {
                    notification.simple(lang.template('系统错误'));
                }

                UP.Global.DA.add({
                    eventName: 'bindPhoneSendCodeError' + dataWrap.code,
                    action: 'click'
                });
            }
        })
    }

    hidePwd(){
        this.setState({
            hidePwd: !this.state.hidePwd
        });
    }

    /**
     * 模拟当前用户的身份标示
     * @param 
     * @return string
     */
    uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random()*16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }

    // 获取当前有效的uuid（有效期5分钟）
    getCurrentUuid() {
        // __ppuuid__ : uuid,timestamp
        var uuid = '';
        var old = cache.getCache('__pcuuid__');
        if (old) {
            var isExpire = this.checkExpire();

            // 若已失效
            if (isExpire) {
                uuid = this.uuid(60);
                cache.setCache('__pcuuid__' , uuid);
                cache.setCache('__pcuuid__stamp__' , +new Date);
            } else {
                uuid = old;
                this.updateValidTime();
            }
        } else {
            uuid = this.uuid(60);
            cache.setCache('__pcuuid__' , uuid);
            cache.setCache('__pcuuid__stamp__' , +new Date);
        }

        return uuid;

    }

    // 判断uuid是否失效(超过1天)
    checkExpire() {
        var stamp = cache.getCache('__pcuuid__stamp__');
        var curStamp = +new Date;
        return curStamp - Number(stamp) > 24 * 60 * 60 * 1000;
    }

    // 更新当前的有效期
    updateValidTime () {
        cache.setCache('__pcuuid__stamp__' , +new Date);
    }

    onSelectOption(data) {
        // console.log(data);
        
        if (!data.inputValuePlusCode) {
            data.inputValuePlusCode = lang.template('国家/地区');
        }

        let state = Object.assign({},{showSelect: false}, data);

        this.setState(state);
    }

    render() {
        let userInfo = UP.Global.getUser();

        let VerifyCodeText;

        if (this.state.disVerifyCode) {
            VerifyCodeText = "s";
        } else {
            VerifyCodeText = lang.template('发送验证码');
        }
        
        return (
            <div className="phone-bind">
                <div className="bind-form-item choosecountry" ref="areaCode">
                    <div className="input-wrap arrow" onClick={this.handleSelectCountry}>
                        <div className="input">
                        {this.state.inputValuePlusCode}&lrm;
                        </div>
                    </div>
                    <CountryView visible={this.state.showSelect} selectOption={this.onSelectOption.bind(this)} ref="countryView"/>
                </div>
                <div className="bind-form-item">
                    <div className="input-wrap">
                        <input 
                            className="input"
                            ref="phone"
                            type="text" 
                            placeholder={lang.template('请输入手机号码')}
                        />
                    </div>
                </div>
                <div className="bind-form-item verifyCode">
                    <div className="input-wrap">
                        <input 
                            className="input"
                            ref="verifyCode"
                            type="tel"
                            placeholder={lang.template('请输入验证码')}
                        />
                    </div>
                    <button className="small-btn" onClick={this.clicVerifyCode} ><span data-second="second"></span>{VerifyCodeText}</button>
                </div>
                <div className="bind-form-item">
                    <div className="input-wrap">
                        <input 
                            className="input"
                            ref="password"
                            type={this.state.hidePwd ? 'password' : 'text'} 
                            placeholder={lang.template('请输入密码')}
                        />
                        <i className={this.state.hidePwd ? 'icon' : 'icon pwd-show'} onClick={this.hidePwd.bind(this)}></i>
                    </div>
                    <p className="mini-tip">{lang.template('密码由6-20位数字和字母组成')}</p>
                </div>
                <div className="bind-pop-tip">
                    <div className="notice">
                        <span className="tip"  ref="tip" dangerouslySetInnerHTML={{ __html: lang.template("绑定手机号码,有利于保护您的账号和资金安全") }}></span>
                    </div>
                </div>
                <div className="phone-bind-btn" onClick={this.handleSubmit}>
                    {lang.template('确认')}
                </div>
            </div>
        );
    }
}

export default BindPhoneView;


// WEBPACK FOOTER //
// ./js/mall/withdraw/bindphone-view.js